import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { XCircle, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainSection() {
  const pains = ['Abrís Instagram y lo cerrás sin publicar', 'Fotos que no reflejan tu calidad real', '45 minutos pensando qué escribir', 'Te clavan el visto al pasar precio'];
  return <section className="py-8 md:py-16 px-4 max-w-4xl mx-auto" data-id="element-251">
      <FadeIn data-id="element-252">
        <h2 className="text-2xl md:text-5xl font-black text-center mb-3 md:mb-6 px-2 text-[#1a1611]" data-id="element-253">
          ¿Cuántos domingos más vas a perder así?
        </h2>

        <div className="text-sm md:text-xl text-[#6b5d4f] text-center mb-5 md:mb-12 space-y-2.5 md:space-y-4 max-w-3xl mx-auto font-medium" data-id="element-254">
          <p data-id="element-255">Perdés horas frente a la pantalla sin saber qué publicar.</p>
          <p className="font-bold text-[#1a1611] text-lg md:text-2xl mt-4 md:mt-8" data-id="element-256">
            No es falta de talento.{' '}
            <span className="text-[#b91c1c]" data-id="element-257">Es falta de un sistema.</span>
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-16" data-id="element-258">
        {pains.map((pain, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-259">
            <motion.div whileHover={{
          scale: 1.02,
          backgroundColor: '#fdfbf7'
        }} className="bg-white border border-[#e8dfd0] rounded-2xl p-4 md:p-6 flex gap-3 md:gap-4 items-start h-full transition-colors shadow-sm" data-id="element-260">
              <XCircle className="text-[#b91c1c] shrink-0 mt-0.5 w-5 h-5 md:w-6 md:h-6" data-id="element-261" />
              <span className="text-sm md:text-lg text-[#1a1611] leading-relaxed font-medium" data-id="element-262">
                {pain}
              </span>
            </motion.div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.6} data-id="element-263">
        <div className="text-center relative" data-id="element-264">
          <div className="absolute inset-0 bg-[#c9a961]/10 blur-3xl rounded-full" data-id="element-265"></div>
          <motion.div animate={{
          y: [0, -5, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative z-10 inline-flex flex-col items-center" data-id="element-266">
            <Sparkles className="text-[#c9a961] mb-2 md:mb-4 w-6 h-6 md:w-8 md:h-8" data-id="element-267" />
            <h3 className="text-2xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#b8860b] via-[#c9a961] to-[#d4af37] drop-shadow-sm px-2" data-id="element-268">
              ¿Y si este fuera el último domingo que pasó así?
            </h3>
          </motion.div>
        </div>
      </FadeIn>
    </section>;
}